import { render, staticRenderFns } from "./contractTable.vue?vue&type=template&id=1f8b2abd&scoped=true"
import script from "./contractTable.vue?vue&type=script&lang=js"
export * from "./contractTable.vue?vue&type=script&lang=js"
import style0 from "./contractTable.vue?vue&type=style&index=0&id=1f8b2abd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b2abd",
  null
  
)

export default component.exports